import { runData } from "../../api/run";
import {
  ImplementationMethod,
  ImplementationMethodExecution,
  ImplementationMethodResponse,
} from "../../types/implementation/method";

export const useRunImplementationMethod = () => {
  const runImplementationMethod = (
    method: ImplementationMethod,
    args: any[] = []
  ) => {
    const exec: ImplementationMethodExecution = {
      method,
      args,
      type: "omega/query-omega/implementation/method/ImplementationMethodExecution",
    };
    return runData(exec).then((res: ImplementationMethodResponse) => {
      return res;
    });
  };
  return { runImplementationMethod };
};
